import { InputLabel } from "@material-ui/core";
import React, { useState } from "react";
import "../style.css";

export const FinancialYearDropdown = ({selectedYear,handleChange}) => {
  // const [selectedYear, setSelectedYear] = useState("");
  const currentYear = new Date().getFullYear();
  const startYear = 2017; // Starting year for financial years
  const financialYears = [];

  // Generate financial years dynamically
  for (let year = currentYear; year >= startYear; year--) {
    financialYears.push(`${year}-${(year + 1).toString().slice(-2)}`);
  }

  // const handleChange = (event) => {
  //   setSelectedYear(event.target.value);
  // };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <InputLabel
        id="demo-simple-select-autowidth-label"
        className="text_label"
        style={{
          fontFamily: "GT-Walsheim-medium",
          fontSize: "12px",
          color: "black",
          lineHeight: "16px",
          minHeight: "16px",
          marginBottom: "6px",
          display: "block",
        }}
      >
        Select Financial Year *
      </InputLabel>
      <select
        id="financialYear"
        className="select-financial-year"
        value={selectedYear}
        onChange={handleChange}
        style={{
          width: "100%",
          fontSize: "14px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          height: "2.15em",
          appearance: "none", // Remove default arrow
          paddingRight: "2em", // Make room for the triangle
          paddingLeft: "0.5em",
          position: "relative",
          boxSizing: "border-box",
          // background: "transparent", // Transparent background
        }}
      >
        <option className="option-for-select" value="">Select Financial Year</option>
        {financialYears.map((year) => (
          <option className="option-for-select" key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <div
      className="triangle-icon"
      style={{top: "70%"}}
      ></div>
    </div>
  );
};

export default FinancialYearDropdown;
